import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DynamicTable from "../../../components/DynamicTable";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import appcolors from "../../../constants/Colors";
import { fetchClients } from "../../../services/Clients";
import AppContainer from "./../../../components/AppContainer/index";
const headerData = ["Ref#", "Joining Date/Time", "Client Details"];
const tableRows = ["idAscending", "clients_date_time", "client_user_details"];

function UserLists() {
  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    if (selectedBranch?.length > 0) {
      handleFetchAllClients();
    }
  }, [selectedBranch]);

  useEffect(() => {
    const filtered = clients.filter((client) => {
      const nameMatch = client?.user?.name
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());
      const emailMatch = client?.user?.email
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());
      return nameMatch || emailMatch;
    });
    setFilteredClients(filtered);
  }, [searchInput, clients]);

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleFetchAllClients = async () => {
    try {
      setIsLoading(true);
      const response = await fetchClients({ branchId: selectedBranch });
      setIsLoading(false);
      if (response.status == 200 || response.status == 201) {
        let data = response?.data?.data;
        setClients(data);
        setFilteredClients(data);
      } else {
        handleSnackbarVal(true, "error", response?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(true, "error", error?.data?.message);
      console.error(error);
    }
  };

  const handleChangeSearchInput = (e) => {
    setSearchInput(e.target.value);
  };

  return (
    <AppContainer
      primaryHeading={"Clients list"}
      secondaryHeading={"View, add, edit and delete your client's details"}
      showSerach
      onChange={handleChangeSearchInput}
      searchValue={searchInput}
    >
      {filteredClients?.length > 0 ? (
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={filteredClients}
        />
      ) : (
        <Typography
          variant="h1"
          fontSize={23}
          textAlign={"center"}
          color={appcolors.black}
          mt={20}
          mb={20}
        >
          No User Found!
        </Typography>
      )}
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
    </AppContainer>
  );
}

export default UserLists;
